import React from 'react';
import { useLanguage } from '../../App';
import aboutRight from '../../Assets/AboutUs/aboutright.png';
import aboutLeft from '../../Assets/AboutUs/aboutleft.png';

const AboutUs = () => {
  const { t } = useLanguage();

  return (
    <div className="relative w-full bg-[#030B15] overflow-hidden flex items-center justify-center
      /* تصغير الارتفاع هنا */
      min-h-fit 
      md:min-h-[300px]    /* تقليل الحد الأدنى للارتفاع بدلاً من 450 */
      xl:h-screen 
      max-h-[1080px] 
      py-12 md:py-16">    {/* الاعتماد على البادينغ لضبط المسافة بدقة */}
      
      {/* الصور الجانبية - تظهر فقط في الشاشات الكبيرة جداً */}
      <div className="hidden xl:block absolute inset-0 pointer-events-none">
        <div className="absolute top-[40%] -translate-y-1/2 right-[-25%] z-10">
          <img 
            src={aboutRight} 
            alt="About Us Right" 
            className="w-[900px] h-[666px] opacity-100 object-contain"
          />
        </div>

        <div className="absolute top-[53%] -translate-y-1/2 left-[-25%] z-10">
          <img 
            src={aboutLeft} 
            alt="About Us Left" 
            className="w-[900px] h-[666px] opacity-100 object-contain"
          />
        </div>
      </div>

      <div className="relative z-20 w-full max-w-[1232px] text-center px-6 mx-auto">
        <h1 className="text-[#1A4D90] font-alexandria font-medium text-[18px] md:text-[21px] xl:text-[25px] leading-[100%] mb-3">
          {t('navbar.about')}
        </h1>
        <h2 className="text-white font-alexandria font-medium text-[22px] md:text-[28px] xl:text-[34px] leading-[1.2] mb-5 px-3">
          {t('hero.subtitle')}
        </h2>
        <p className="text-[#CFCFCF] font-alexandria font-light text-[15px] md:text-[18px] xl:text-[25px] leading-[1.6] max-w-[1000px] mx-auto px-4">
          {t('hero.description')}
        </p>
      </div>
    </div>
  );
};

export default AboutUs;